import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { FC, Fragment } from 'react';
import { useResumeFeatures } from '../model';

interface RenderFeatureProps {
  featurePath: string;
  data?: CatalogItemViewModel;
}

export const ResumeFeatureRender: FC<RenderFeatureProps> = ({ featurePath, data }) => {
  const feature = useResumeFeatures(featurePath);
  const features = Array.isArray(feature) ? feature : [feature];
  if (!feature || !data) {
    return null;
  }
  return (
    <Fragment>
      {features.map((FeatureRender, index) => FeatureRender && <FeatureRender key={`${featurePath}_${data.id}_${index}`} {...data} />)}
    </Fragment>
  );
};
